import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'
import classNames from 'classnames'
import Icon from './Icon'
import '../styles/VehicleListItem.scss'
import HeroShot from './HeroShot'
import ProductTypeIllustration from './ProductTypeIllustration'

export default class VehicleListItem extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    link: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    heroshot: PropTypes.object.isRequired,
    variant: PropTypes.oneOf(['default', 'unified']),
    unifiedCardType: PropTypes.oneOf(['productType', 'model']),
  }

  static defaultProps = {
    onClick: null,
    variant: 'default',
    unifiedCardType: 'productType',
  }

  render() {
    const { title, subtitle, link, onClick, heroshot, variant, unifiedCardType } = this.props
    const isUnified = variant === 'unified'

    return (
      <Link
        className={classNames(
          'VehicleListItem',
          isUnified && 'VehicleListItem--unified',
          isUnified && unifiedCardType === 'model' && 'VehicleListItem--model',
        )}
        to={link}
        {...(typeof onClick === 'function' ? {onClick} : null)}>
        {isUnified && unifiedCardType === 'productType' ? (
          <ProductTypeIllustration productType={heroshot.vehicleProductType} />
        ) : isUnified ? (
          <HeroShot {...heroshot}/>
        ) : null}
        <div className="vehicle-text">
          <span className="title">
            {title}
            {isUnified ? <Icon type="arrow-right" /> : null}
          </span>
          {subtitle && <span className="subtitle">{subtitle}</span>}
        </div>
        {!isUnified ? <HeroShot {...heroshot}/> : null}
      </Link>
    )
  }
}
